export default "__VITE_ASSET__BSr00mY6__"